import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { getTodayDateString } from '@/lib/date'
import { RouteStore } from './types'
import { initialRouteState } from './state'
import { createRouteActions } from './actions'
import { createRouteEffects } from './effects'

export const useRouteStore = create<RouteStore>()(
  persist(
    (...a) => ({
      ...initialRouteState,
      ...createRouteActions(...a),
      ...createRouteEffects(...a),
    }),
    {
      name: 'route-storage',
      partialize: (state) => ({
        selectedVehicleId: state.selectedVehicleId,
        selectedDate: state.selectedDate,
        dateSelectedOn: state.dateSelectedOn,
      }),
      onRehydrateStorage: () => (state) => {
        if (!state) return
        const today = getTodayDateString()
        // Reset selectedDate to today if the selection was made on a different day
        if (state.dateSelectedOn !== today) {
          state.selectedDate = today
          state.dateSelectedOn = today
        }
      },
    }
  )
)

export * from './selectors'
export type {
  RouteState,
  RouteActions,
  RouteEffects,
  RouteStore,
} from './types'
